import { render, staticRenderFns } from "./n-vip.vue?vue&type=template&id=1be3a502"
import script from "./n-vip.vue?vue&type=script&lang=js"
export * from "./n-vip.vue?vue&type=script&lang=js"
import style0 from "./n-vip.vue?vue&type=style&index=0&id=1be3a502&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports